// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { ResourceUriDocument_abstract } from './../abstract/SagaSchema/ResourceUriDocument_abstract';
export class ResourceUriDocument extends ResourceUriDocument_abstract {}
